import { NgModule } from '@angular/core';

import { IsGroupAdminPipe } from './is-group-admin.pipe';

@NgModule({
  exports: [IsGroupAdminPipe],
  declarations: [IsGroupAdminPipe],
})
export class IsGroupAdminModule {}
